<template>
  <div class="formNav">
    <div>
      <div class="header">
      <h3>{{ headerTitle }}</h3>
      <h3>Qualification inquiry</h3>
    </div>
    <div class="boxForm" style="width: 100%; margin-top: -70px">
      <div
        class="contentnav"
        style="width: 1000px; margin: 0 auto; text-align: center"
      >
        <!-- <h3>资质查验</h3> -->
        <div class="contaniner" style="width: 1000px; margin: 0 auto;min-height: 450px;">
          <el-radio-group v-model="activeName" style="margin: 50px 0 20px 0">
            <el-radio-button label="1">按证件号码查询</el-radio-button>
            <el-radio-button label="2">按资质编号查询</el-radio-button>
          </el-radio-group>
          <div class="forminspect">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="demo-ruleForm"
            >
              <el-form-item label="姓名" prop="surname">
                <el-input
                  v-model="ruleForm.surname"
                  placeholder="请填写姓名"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="证件号码"
                prop="idcardNum"
                v-if="!certCodeShow"
              >
                <el-input
                  v-model="ruleForm.idcardNum"
                  placeholder="请填写证件号码"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="资质编号"
                prop="cerCode"
                v-if="certCodeShow"
              >
                <el-input
                  v-model="ruleForm.cerCode"
                  placeholder="请填写资质编号"
                ></el-input>
              </el-form-item>
              <div class="itemFlex">
                <el-form-item label="验证码" prop="check_code">
                  <el-input
                    v-model="ruleForm.check_code"
                    placeholder="请填写验证码"
                    @keyup.enter.native = "submitForm('ruleForm')"
                    style="
                      width: 260px;
                      height: 45px;
                      display: flex;
                      align-items: center;
                    "
                  ></el-input>
                </el-form-item>
                <div style="width: 130px; height: 50px; margin: 0 auto;display: flex;align-items: center;justify-content: space-around;">
                  <img style="width: 90%; height: 30px" :src="register.image" @click="Changeone()"/>
                  <!-- <span
                    style="
                      color: red;
                    "
                  >
                    两位字符验证码
                  </span> -->
                </div>
              </div>
            </el-form>
<!-- @keyup.enter.native = "submitForm('ruleForm')" -->
            <el-button type="primary" @click="submitForm('ruleForm')"  
              >查 询</el-button
            >
          </div>
        </div>
      </div>
    </div>
    </div>
    <Foot class="foot" />
  </div>
</template>

<script>
import Foot from "../components/Foot.vue";
import { enterpriselogincode, searchCertif } from "../api/api";
export default {
  name: "",
  components: { Foot },
  props: {},
  data() {
    let checkIdcard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入证件号码"));
      } else {
        const reg =
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!reg.test(this.ruleForm.idcardNum)) {
          const msg = rule.msg ? rule.msg : "证件格式不正确";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    return {
      register: { image: "", uuid: "" },
      activeName: "1",
      ruleForm: {
        surname: "",
        cerType: "", //资质类型
        idcardNum: "",
        check_uuid: "",
        check_code: "",
        cerCode: "", //资质编号
      },
      certCodeShow: false,
      headerTitle: "分级评价人员",
      rules: {
        surname: [
          { required: true, message: "请填写姓名", trigger: "blur" },
        ],
        idcardNum: [
          {
            required: true,
            message: "请填写证件号码",
            trigger: "blur",
          },
          // { validator: checkIdcard, trigger: ["blur", "change"] },
        ],
        check_code: [
          {
            required: true,
            message: "请填写验证码",
            trigger: "blur",
          },
        ],
        cerCode:[
        {
            required: true,
            message: "请填写资质编号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {
    activeName() {
      if (this.activeName == 1) {
        this.certCodeShow = false;
      } else {
        this.certCodeShow = true;
      }
      this.$refs.ruleForm.clearValidate()
    },
    // queryId(){
    //   if(this.queryId == 31){
    //     this.headerTitle = '创新管理师'
    //     this.certype = 1
    //   }else if(this.queryId == 32){
    //     this.headerTitle = '分级评价师'
    //     this.certype = 2
    //   }else if(this.queryId == 33){
    //       this.headerTitle = '知识产权质量人员'
    //       this.certype = 3
    //   }
    // }
  },
  created() {},
  mounted() {
    this.initTable();
    
  },
  methods: {
    //    看不清换一张
    Changeone() {
      this.initTable(); //输出为：newValue  最新修改的值
    },
    //获取验证码
    initTable() {
      // this.$router.go(0)
      enterpriselogincode().then((res) => {
        if (res.code == "1000") {
          var register = res.data;
          let str = register.img.replace(/\. +/g, "");
          str = str.replace(/[\r\n]/g, "");
          console.log(str);
          this.register.image = str;
          this.ruleForm.check_uuid = res.data.uuid;
          this.register.uuid = register.uuid;
          this.$nextTick(function () {
            this.register.image = str;
            this.register.uuid = register.uuid;
          });
          console.log(this.register);
        } else {
          console.log(1);
          // if (res.code == "2008"){ //验证码过期
          //   // this.msg = "验证码过期";
          //   this.initTable()
          // }
        }
      });
    },
    goIndex() {
      this.$router.push({ name: "index" });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // const reg =
          //   /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          // if (!reg.test(this.ruleForm.idcardNum)) {
          //   this.$message.error("身份证格式不正确");
          //   return;
          // }

          let formdata = {
            surname: this.ruleForm.surname,
            cerType: 2, //资质类型
            idcardNum: this.ruleForm.idcardNum,
            check_uuid: this.register.uuid,
            check_code: this.ruleForm.check_code,
            cerCode: this.ruleForm.cerCode, //资质编号
          };
          searchCertif(this.$qs.stringify(formdata)).then((res) => {
            if(res.code == 1000){
              console.log(res.data)
              this.$router.push({ name: "InspectionPerson",params:{
                data:JSON.stringify(res.data)
              } });
            }else{
              this.$message.error(res.msg)
              if (res.code == "2008"){ //验证码过期
                // this.msg = "验证码过期";
                this.initTable()
              }
            }
           
          });
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
// .foot {
//   position: absolute;
//   bottom: 0;
//   right: 0;
//   left: 0;
// }
.formNav {
  width: 100%;
  height: calc(100% - 82px);
  // background: #f6f8fe;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .header {
    padding-top: 120px;
    box-sizing: border-box;
    height: 400px;
    font-size: 40px;
    text-align: left;
    background: url("../assets/qualify-bg.png") 100% 100% no-repeat;
    background-size: 100% 100%;
    color: #fff;
    h3 {
      width: 1100px;
      margin: 0 auto;
      margin-bottom: 10px;
      font-weight: normal;
    }
    :last-child {
      font: lighter 50px/80px PMingLiU;
      color: #c5c4c4;
      // font-style: SourceHanSansCN-Light;
      font-weight: 300;
      color: #ffffff;
      opacity: 0.6;
    }
  }
}
.boxForm {
  // height: calc(100% - 440px);
  margin-bottom: 30px;
}
.contentnav {
  background: #fff;
  padding: 0 40px;
  min-height: 400px;
  border-radius: 15px;
  box-shadow: 1px 2px 2px 0px #f0f0f0;

  h3 {
    text-align: left;
    line-height: 100px;
    font-size: 16px;
    // border-bottom: 1px solid #f0f0f0;
  }
}
.forminspect {
  width: 500px;
  margin: 30px auto;
  // ::v-deep .el-input__inner {
  //   width: 300px;
  // }
  .itemFlex {
    display: flex;
    // align-items: center;
    // margin-left: 20px;
    // margin-top: 30px;
    // img {
    //   margin-left: 10px;
    //   margin-bottom: 20px;
    // }
  }
  ::v-deep .el-button--primary {
    width: 320px;
    margin-left: 10px;
    background: #607fea;
  }
}
.el-form-item {
  text-align: left;
}
::v-deep .el-radio-button__inner {
  // display: flex;
  // justify-content: space-around;
  padding: 15px 130px;

  // ::v-deep .el-radio-button__inner{
  //   padding: 10px 100px;
  // }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #607fea;
}
</style>
